import React from "react";
import FeatureItem from "./FeatureItem";

const FeatureGrid = ({ features }) => {
  return (
    <div className="grid xl:grid-cols-4 md:grid-cols-3 ml:grid-cols-2 grid-cols-1 ml:gap-x-3 gap-y-1.5">
      {features?.map((feature, index) => (
        <FeatureItem key={index} label={feature.baslik} icon={feature.icon} />
      ))}
    </div>
  );
};

export default FeatureGrid;
